import { render } from "./guide-article.vue?vue&type=template&id=063c1176"
import script from "./guide-article.vue?vue&type=script&lang=js"
export * from "./guide-article.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__